import { ASC, COLORS, SORT_TYPES } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { SmallText } from '../presentation/Text'
import Button from '../actions/Button'
import Link from '../actions/Link'
import List from '../list/List'
import RadioListItem from '../list/RadioListItem'
import Separator from '../helpers/Separator'
import SideModal, { SideModalHeader } from '../structure/SideModal'

const SortSideModal = ({ onClose, open, fields, onSubmit }) => {
  const { t } = useTranslation()
  const [type, setType] = useState(ASC)
  const [field, setField] = useState('')

  fields = fields || []

  const handleSubmit = () => onSubmit({ type, field })

  let clearSortLink = false
  if (!!field) {
    clearSortLink = (
      <Link onClick={() => setField('')}>
        <SmallText color={COLORS.red}>{t('clean')}</SmallText>
      </Link>
    )
  }

  return (
    <SideModal
      open={open}
      onClose={onClose}
      footer={
        <Button fullWidth onClick={handleSubmit}>
          {t('sort')}
        </Button>
      }
    >
      <SideModalHeader title={t('sortBy')} onClose={onClose} leftContent={clearSortLink} />

      <List>
        {fields.map(({ value, label }) => (
          <RadioListItem
            key={label + value}
            selected={value === field}
            onSelect={() => setField(value)}
            label={label}
          />
        ))}
      </List>

      <Separator bgColor={COLORS.light1} weight={4} />

      <List>
        {SORT_TYPES.map(optionType => (
          <RadioListItem
            key={optionType}
            selected={optionType === type}
            onSelect={() => setType(optionType)}
            label={t(optionType)}
          />
        ))}
      </List>
    </SideModal>
  )
}

export default SortSideModal
